import { apiSlice } from "../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTrending: builder.query({
            query: () => ({
                url: "/workbookapi/trending",
                method: "GET",
            }),

        }),
    }),
});

export const { useGetTrendingQuery } = sqlApiSlice; 
